import React, { useState, useEffect } from "react";
import "./Spinner.css";

function Spinner({
  showProgress,
}) {
  const [logs, setLogs] = useState([]);
  const [now, setNow] = useState(() => performance.now());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(performance.now());
      if (window.lagLog && window.lagLog.length > 0) {
        setLogs(currentLogs => {
          const lastThreeLogs = window.lagLog.slice(-1);
          const newLogs = lastThreeLogs.map(log => ({ title: log.title, value: log.value }));
          
          if (JSON.stringify(newLogs) !== JSON.stringify(currentLogs)) {
            return newLogs;
          }
          return currentLogs;
        });
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  const showLogContainer = showProgress && (now > window.appStartTime + 1000);

    return (
      <>
      <svg className="spinner" viewBox="0 0 50 50">
        <circle
          className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        ></circle>
      </svg>
      {showLogContainer && (
        <div className="spinner-log-container">
          {logs.map((log, index) => (
            <div key={index} className="spinner-log-text">
              {log.title}{log.value ? ` ${log.value}` : ''}
            </div>
          ))}
        </div>
      )}
      </>
	);
}

export default Spinner;
